import { useMemo } from 'react';
import { Column } from 'react-table';
import { nextTableColumns } from '@shared/modules/next-table/helpers/next-table-columns';
import { ICurrency } from '../../interfaces';
import { currencyQueryKeys } from '../../utils';

export const useCurrenciesTableColumns = (): Column<ICurrency>[] => {
  const baseColumns = useMemo<Column<ICurrency>[]>(
    () => [
      { ...nextTableColumns.small, Header: 'Kod', id: currencyQueryKeys.id, accessor: (r) => r.id },
      { accessor: (r) => r.name, id: currencyQueryKeys.name, Header: 'Ad' },
      { ...nextTableColumns.date, accessor: (r) => r.createdAt, id: currencyQueryKeys.createdAt, Header: 'Yaradılma tarixi' },
    ],
    [],
  );

  return baseColumns;
};
